var subscription = {
	videoSP: "",
	videoPC: "",
	init: function(){
		subscription.videoSP = $("video#main_movie_sp");
		subscription.videoPC = $("video#main_movie_pc");
		subscription.videoSP[0].muted = true;
		subscription.videoSP[0].playsinline = true;
		subscription.videoSP[0].loop = true;
		
		subscription.videoPC[0].muted = true;
		subscription.videoPC[0].loop = true;
		subscription.videoPC[0].playsinline = true;
		
		common.resize();
		subscription.checkVideo();
		setInterval(function(){
			common.resize();
		}, 100);
	},
	resize: function(){
		let winW = $(window).width(),
			winH = $(window).height();
		
		if (window.matchMedia('all and (min-width : 864px)').matches) {
			isSmallScreen = false;
		} else if(window.matchMedia('all and (min-width : 0px)').matches) {
			isSmallScreen = true;
		}
		if(!isSmallScreen){
			let sizes = fs(1920,1080,864,486,winW,winH);
			$("#movie_main video#main_movie_pc").css({
				"width": "",
				"height": "",
				"top": "",
				"left": ""
			});
			$("#kv").css({
				"width": "",
				"height": ""
			});
			$("#movie_main").css({
				"width": "",
				"height": ""
			});
		}else{
			$("#movie_main").css({
				"width": winW + "px",
				"height": winH + "px"
			});
			$("#kv").css({
				"height": winH + "px"
			});
			let sizes = fs(1920, 3634, 320, 569, winW, winH);
			$("#movie_main video#main_movie_sp").css({
				"width": sizes[0] + "px",
				"height": sizes[1] + "px",
				"bottom": 0 + "px",
				"left": sizes[2] + "px"
			});
		}
		subscription.checkVideo();
	},
	checkVideo: function(){
		if(subscription.videoSP === ""){
					
		}else{
			if(isSmallScreen){
				subscription.videoSP[0].play();
				subscription.videoPC[0].pause();
			}else{
				subscription.videoSP[0].pause();
				subscription.videoPC[0].play();
			}
		}
	}
}
